import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar, Sparkles } from "lucide-react";
import heroBg from "@/assets/hero-bg.jpg";
import { BookingDialog } from "./BookingDialogLazy";
import { ParallaxLayer } from "./animations/ParallaxSection";
import { MagneticButton } from "./animations/MagneticButton";
import { WordByWordReveal } from "./animations/WordByWordReveal";
import { AnimatedGradientText } from "./animations/AnimatedGradientText";
import { FloatingParticles } from "./animations/FloatingParticles";
import { ScrollIndicator } from "./animations/ScrollIndicator";
import { Badge } from "./ui/badge";
const Hero = () => {
  const [showBooking, setShowBooking] = useState(false);
  
  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background"
      style={{
        animation: 'page-entry 1.5s ease-out forwards',
        opacity: 0
      }}
    >
      {/* Preload hero image with high priority for faster LCP */}
      <img src={heroBg} alt="" fetchPriority="high" style={{ display: 'none' }} />
      
      {/* Layer 1: Background Image (slowest parallax) */}
      <ParallaxLayer speed={0.3} className="absolute inset-0">
        <div 
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroBg})`
          }}
        />
      </ParallaxLayer>

      {/* Layer 2: Gradient Overlay */}
      <ParallaxLayer speed={0.5} className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-background" />
      </ParallaxLayer>

      {/* Layer 3: Floating Particles */}
      <ParallaxLayer speed={0.7} className="absolute inset-0">
        <FloatingParticles count={6} />
      </ParallaxLayer>

      {/* Layer 4: Text Content */}
      <ParallaxLayer speed={0.8} className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
        <div className="container-custom text-center max-w-5xl">
          <div className="flex flex-col items-center gap-6">
            {/* Headline composition */}
            <div className="flex flex-col items-center gap-2 md:gap-3">
              <WordByWordReveal
                text="Medienproduktion in Mannheim und Rhein-Neckar"
                className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight"
                startDelay={1000}
                wordDelay={100}
              />
              <AnimatedGradientText
                className="text-2xl md:text-4xl lg:text-[2.75rem] font-bold tracking-wide md:whitespace-nowrap"
                delay={1700}
              >
                <p>Foto · Video · Social Media</p>
              </AnimatedGradientText>
            </div>

            {/* Description */}
            <p
              className="text-base md:text-lg text-gray-300 max-w-3xl"
              style={{
                animation: 'fade-in 0.8s ease-out forwards',
                animationDelay: '2.3s',
                opacity: 0
              }}
            >
              Geschichten, die berühren. Ergebnisse, die überzeugen. Fotografie, Film und Social-Media-Content für Unternehmen in Mannheim und der Rhein-Neckar-Region.
            </p>

            {/* CTA Buttons */}
            <div 
              className="flex flex-col sm:flex-row gap-4 mt-4 pointer-events-auto"
              style={{
                animation: 'fade-in 0.8s ease-out forwards',
                animationDelay: '2.5s',
                opacity: 0
              }}
            >
              <MagneticButton
                onClick={() => setShowBooking(true)}
                className="border-primary/30 bg-primary/5 text-primary backdrop-blur-xs hover:bg-primary/10 px-8 py-4 text-lg rounded-full font-semibold transition-all border flex items-center justify-center gap-2"
                strength={0.3}
              >
                <Calendar className="w-5 h-5" />
                Kostenloses Beratungsgespräch
              </MagneticButton>
            </div>
          </div>
        </div>
      </ParallaxLayer>

      {/* Scroll Indicator */}
      <ScrollIndicator targetId="philosophy" delay={2500} />

      <BookingDialog open={showBooking} onOpenChange={setShowBooking} />
    </section>
  );
};
export default Hero;